export interface ParsedTime {
  hours: number;
  minutes: number;
}

export function parseLooseTime(input: string): ParsedTime | null {
  if (!input) return null;
  let s = input.trim().toLowerCase().replace(/\u202f|\u00a0/g, ' ');
  if (!s) return null;

  let meridiem: 'am' | 'pm' | null = null;
  const meridiemMatch = s.match(/\s*(a\.?m\.?|p\.?m\.?|a|p)\s*$/i);
  if (meridiemMatch) {
    meridiem = meridiemMatch[1][0] === 'a' ? 'am' : 'pm';
    s = s.slice(0, -meridiemMatch[0].length);
  }

  s = s.replace(/\s+/g, '').replace(/\./g, ':');

  let h: number;
  let min: number;

  if (s.includes(':')) {
    const parts = s.split(':');
    if (parts.length !== 2) return null;
    h = parseInt(parts[0], 10);
    min = parseInt(parts[1], 10);
    if (parts[1].length === 0 || parts[1].length > 2) return null;
  } else {
    if (!/^\d+$/.test(s)) return null;
    if (s.length === 1 || s.length === 2) {
      h = parseInt(s, 10);
      min = 0;
    } else if (s.length === 3) {
      h = parseInt(s.slice(0, 1), 10);
      min = parseInt(s.slice(1), 10);
    } else if (s.length === 4) {
      h = parseInt(s.slice(0, 2), 10);
      min = parseInt(s.slice(2), 10);
    } else {
      return null;
    }
  }

  if (isNaN(h) || isNaN(min)) return null;
  if (min < 0 || min > 59) return null;

  if (meridiem) {
    if (h < 1 || h > 12) return null;
    if (meridiem === 'pm' && h < 12) h += 12;
    if (meridiem === 'am' && h === 12) h = 0;
  } else {
    if (h < 0 || h > 23) return null;
  }

  return { hours: h, minutes: min };
}

export function formatTimeForInput(d: Date | null): string {
  if (!d || isNaN(d.getTime())) return '';
  return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
}
